import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {clearDiv} from "../../helpers/builders";

export class ShaperCircuitHeaderDashlet extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastHeader = null;
        this.lastQoo = null;
    }

    title() {
        return "Header";
    }

    channelRequests() {
        return [ "CircuitHeader", "CircuitDetail" ];
    }

    buildContainer() {
        let base = super.buildContainer();
        base.style.overflow = "visible";
        let content = document.createElement("div");
        content.style.width = "100%";
        content.id = "ltsCircuitHeader_" + this.slot;
        content.classList.add("text-center", "text-muted", "small", "py-2");
        this.contentId = content.id;
        let limits = document.createElement("div");
        limits.id = "ltsCircuitHeaderLimits_" + this.slot;
        limits.classList.add("d-flex", "flex-wrap", "justify-content-center", "align-items-center", "gap-3");
        this.limitsId = limits.id;
        content.appendChild(limits);

        let reports = document.createElement("div");
        reports.id = "ltsCircuitHeaderReports_" + this.slot;
        this.reportsId = reports.id;
        content.appendChild(reports);
        base.appendChild(content);
        return base;
    }

    setup() {
        super.setup();

        if (window.splynxEmbed) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        this.hash = urlParams.get("circuit");

        let limitsTarget = document.getElementById(this.limitsId);
        if (limitsTarget) {
            limitsTarget.innerHTML = "<i class='fa fa-spinner fa-spin'></i> Loading...";
        }

        let reportsTarget = document.getElementById(this.reportsId);
        if (reportsTarget) {
            reportsTarget.classList.add("mt-2", "d-flex", "flex-wrap", "justify-content-center", "gap-2");
            const analysisLink = document.createElement("a");
            analysisLink.className = "btn btn-sm btn-outline-secondary";
            const nodeId = urlParams.get("nodeId") || window.nodeId || "";
            analysisLink.href = `/circuit_analysis.html?circuit=${encodeURIComponent(this.hash || "")}&nodeId=${encodeURIComponent(nodeId)}`;
            analysisLink.innerHTML = "<i class='fa fa-flask me-1'></i>Circuit analysis";
            reportsTarget.appendChild(analysisLink);
        }

        // Add report selector dropdown
        $.get(`/api/circuitReports/${this.hash}`, (data) => {
            if (data.length > 0) {
                let select = document.createElement("select");
                select.className = "form-select form-select-sm";
                select.innerHTML = `
                    <option selected>-- Please select a saved report --</option>
                    ${data.map(report =>
                    `<option value="${report.id}">${report.title} (${new Date(report.tick * 1000).toLocaleDateString()})</option>`
                ).join('')}
                `;
                select.onchange = (e) => {
                    if (e.target.value) {
                        window.location.href = `/circuit_report.html?id=${e.target.value}`;
                    }
                };
                if (reportsTarget) {
                    reportsTarget.appendChild(select);
                }
            }
        }).fail(() => console.error("Failed to load circuit reports"));
    }

    renderHeader(data) {
        let body = document.getElementById(this.limitsId);
        if (!body) return;
        clearDiv(body);

        const nameParts = [];
        if (data.circuit_name) {
            nameParts.push(data.circuit_name);
        }
        if (data.circuit_id) {
            if (data.circuit_name && data.circuit_id !== data.circuit_name) {
                nameParts.push(`(${data.circuit_id})`);
            } else if (!data.circuit_name) {
                nameParts.push(data.circuit_id);
            }
        }
        const displayName = nameParts.length ? nameParts.join(" ") : `Circuit ${data.circuit_hash || ""}`.trim();

        const formatLimit = (value) => (typeof value === "number" ? `${value} Mbps` : "-");

        const nameSpan = document.createElement("span");
        nameSpan.className = "fw-semibold text-body d-inline-flex align-items-center gap-1 redactable";
        nameSpan.innerHTML = "<i class='fa fa-plug'></i>";
        nameSpan.appendChild(document.createTextNode(` ${displayName}`));

        const maxSpan = document.createElement("span");
        maxSpan.className = "d-inline-flex align-items-center flex-wrap";
        maxSpan.innerHTML = `<i class="fa fa-gauge me-1"></i>Max
            <span class="ms-2"><i class="fa fa-arrow-down me-1"></i>${formatLimit(data.download_max_mbps)}</span>
            <span class="ms-2"><i class="fa fa-arrow-up me-1"></i>${formatLimit(data.upload_max_mbps)}</span>`;

        const minSpan = document.createElement("span");
        minSpan.className = "d-inline-flex align-items-center flex-wrap";
        minSpan.innerHTML = `<i class="fa fa-flag-checkered me-1"></i>Min
            <span class="ms-2"><i class="fa fa-arrow-down me-1"></i>${formatLimit(data.download_min_mbps)}</span>
            <span class="ms-2"><i class="fa fa-arrow-up me-1"></i>${formatLimit(data.upload_min_mbps)}</span>`;
        const qooSpan = document.createElement("span");
        qooSpan.className = "d-inline-flex align-items-center flex-wrap";
        qooSpan.innerHTML = `<i class="fa fa-bullseye me-1"></i>QoO
            <span class="ms-2">${formatQoo(this.lastQoo)}</span>`;

        body.appendChild(nameSpan);
        body.appendChild(maxSpan);
        body.appendChild(minSpan);
        body.appendChild(qooSpan);

        if (window.splynxEmbed) {
            const reportsTarget = document.getElementById(this.reportsId);
            if (reportsTarget) {
                reportsTarget.classList.add("mt-2");
                reportsTarget.innerHTML = "";
                const link = document.createElement("a");
                const nodeId = window.splynxEmbedConfig?.node_id || "";
                const circuitHash = data.circuit_hash || "";
                link.href = `https://insight.libreqos.com/shaper_circuit.html?circuit=${encodeURIComponent(circuitHash)}&nodeId=${encodeURIComponent(nodeId)}`;
                link.target = "_blank";
                link.rel = "noopener";
                link.className = "btn btn-sm btn-outline-primary";
                link.innerHTML = "<i class='fa fa-up-right-from-square me-1'></i>Open in Insight";
                reportsTarget.appendChild(link);
            }
        }
    }

    onMessage(msg) {
        if (!msg?.Data) return;
        if (msg.Data.target === "circuit_qoo") {
            this.lastQoo = extractLatestQoo(msg.Data.blob || {});
            if (this.lastHeader) {
                this.renderHeader(this.lastHeader);
            }
            return;
        }
        if (msg.Data.target !== "circuit_header") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }

        const data = msg.Data.blob || {};
        this.lastHeader = data;
        this.renderHeader(data);
        this.rendered = true;
    }
}

function latestNumeric(values) {
    if (!Array.isArray(values)) return null;
    for (let i = values.length - 1; i >= 0; i -= 1) {
        const n = Number(values[i]);
        if (Number.isFinite(n)) return n;
    }
    return null;
}

function extractLatestQoo(qooMap) {
    const first = Object.values(qooMap || {})[0];
    if (!first) return null;
    const overall = latestNumeric(first.qoo_overall);
    if (overall !== null) return overall;
    const up = latestNumeric(first.qoo_up);
    const down = latestNumeric(first.qoo_down);
    if (up !== null && down !== null) {
        return Math.min(up, down);
    }
    return up ?? down ?? null;
}

function formatQoo(value) {
    if (value === null || value === undefined || Number.isNaN(value)) return "—";
    return `${Math.round(value)}`;
}
